module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/resonio/briefing_en-fca06b88b06c9663c81cf352e5c0d029.gif";